module.exports = __webpack_public_path__ + "img/4.4861061c.png";